<template class="appColorBack">
    <!--v-container class="appColorBack" :style="{backgroundImage: `url(${backgroundImage})`, height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundSize: 'cover', backgroundPosition: 'center center'}">-->

    <v-dialog
      v-model="dialog"
      width="auto"
    >
      <v-card
        max-width="400"
        prepend-icon="mdi-update"
        :text="textError"
        :title="titleError"
      >
        <template v-slot:actions>
          <v-btn
            class="ms-auto"
            text="Cerrar"
            @click="dialog = false"
          ></v-btn>
        </template>
      </v-card>
    </v-dialog>

  <video ref="videoPlayer" class="appColorBack" style="width: 100%; height: 100%; position: fixed; top:0; margin: 0; left: 0; right: 0; z-index:999" v-if="showVideo" @ended="showVideo = false" autoplay muted :src="require('../assets/video.mp4')"></video>
  <v-btn color="deep-orange" v-if="showVideo" style="position: fixed; bottom: 20px; right: 20px; z-index:1000" @click="toggleMute" icon>
      <v-icon>{{ isMuted ? 'mdi-volume-mute' : 'mdi-volume-high' }}</v-icon>
  </v-btn>
  
    <v-btn v-if="showVideo"  prepend-icon="mdi-car-battery" x-small style="position: fixed; bottom: 20px; right: 80px; z-index:1000; font-size: 9px;" stacked  color="deep-orange" @click="skipVideo">Buscar <br> batería</v-btn>


     <v-btn v-if="showVideo"  prepend-icon="mdi-store" x-small stacked style="position: fixed; bottom: 20px; right: 160px; z-index:1000; font-size: 9px;"  color="deep-orange" @click=" skipVideoCentros">Centros<br>de Servicio</v-btn>
  
  <!--<v-btn color="deep-orange" v-if="showVideo" style="position: fixed; bottom: 20px; right: 80px; z-index:1000" @click="skipVideo">
      Buscar Batería
  </v-btn>-->
    
  <v-app v-if="!showVideo">
    <v-app-bar
        app
        elevated
        style="position: fixed; top: 0; left: 0; right: 0; z-index: 1000;"
      >
      <v-img
        :src="require('../assets/logo-pgtpower.svg')"
        contain
        height="80"
      />
      <v-spacer></v-spacer>
      <v-btn color="deep-orange
      " icon @click.stop="drawer = !drawer">
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" app>
      <v-list>
        <v-list-item v-for="(item, index) in menuItems" :key="index">
          <v-list-item-title color="deep-orange" @click="section=item">{{ item }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-content  v-if="section==''" class="appColorBack" :style="{backgroundImage: `url(${backgroundImage})`, height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundSize: 'cover', backgroundPosition: 'center center'}">
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col class="mb-4">
              <v-btn prepend-icon="mdi-car-battery" stacked  color="deep-orange" @click="section='Buscar mi Bateria'">Buscar batería</v-btn>
          </v-col>
          <v-col class="mb-4">
            <v-btn prepend-icon="mdi-store" stacked  color="deep-orange" @click="section='Centros de Servicio'">Centros de Servicio</v-btn>
          </v-col>
          <v-col class="mb-4">
            <v-btn disabled prepend-icon="mdi-newspaper" stacked  color="deep-orange" @click="section='Información y Noticias'">Información y noticias</v-btn>
          </v-col>
          <v-col class="mb-4">
            <v-btn disabled prepend-icon="mdi-heart" stacked  color="deep-orange" @click="section='Tu garantía'" >Validar Garantía</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-content>

    <v-content  v-else-if="section=='Buscar mi Bateria' &&  results.length<=0" class="appColorBack" :style="{backgroundImage: `url(${backgroundImage})`, height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundSize: 'cover', backgroundPosition: 'center center'}">
      <v-container class="fill-height" fluid>
        <v-row class="text-center">
          <!--<v-col cols="12">
            <v-img
              :src="require('../assets/logo-pgtpower-blank.svg')"
              class="my-3"
              contain
              height="50"
            />
            <v-btn color="red" @click="section=''" small>Regresar</v-btn>
          </v-col>-->
          
          <v-col cols="12">
            <v-row>
              <v-col cols="12">
                <h1 style="font-size: 7vw; font-family: Arial, Helvetica, sans-serif; font-weight: bolder; text-align: center; text-shadow: 1px 1px 4px #000; color:#FFF;">Busca tu bateria fácilmente</h1>
              </v-col>
              <v-col cols="12">
                <template v-if="versionSearch === 'autocomplete'">
                  <v-autocomplete
                    v-model="make"
                    :items="marcas"
                    label="Marca"
                    item-text="name"
                    item-value="value"
                    variant="solo"
                  ></v-autocomplete>

                  <v-autocomplete
                    v-model="model"
                    :items="autos"
                    label="Modelo Auto"
                    item-text="name"
                    item-value="value"
                    :disabled="autos.length === 0"
                    variant="solo"
                  ></v-autocomplete>
                </template>

                <template v-else>
                  <v-select
                    v-model="make"
                    :items="marcas"
                    label="Marca"
                    item-text="name"
                    item-value="value"
                    variant="solo"
                  ></v-select>

                  <v-select
                    v-model="model"
                    :items="autos"
                    label="Modelo Auto"
                    item-text="name"
                    item-value="value"
                    :disabled="autos.length === 0"
                    variant="solo"
                  ></v-select>
                </template>
              </v-col>
              <v-col cols="12">
                <v-btn  color="grey-darken-1" @click="section=''" small>Regresar</v-btn>
                <v-btn prepend-icon="mdi-car-battery" stacked  color="deep-orange" :disabled="!make || !model" @click="searchBattery()" small>
                  <span><i class="far fa-search"></i>Buscar Bateria</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
      </v-row>
      </v-container>
    </v-content>
    <v-content  v-else-if="section=='Centros de Servicio' &&  resultsCentros.length<=0" class="appColorBack" :style="{backgroundImage: `url(${backgroundImage})`, height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundSize: 'cover', backgroundPosition: 'center center'}">
      <v-container class="fill-height" fluid>
        <v-row class="text-center">
          <!--<v-col cols="12">
            <v-img
              :src="require('../assets/logo-pgtpower-blank.svg')"
              class="my-3"
              contain
              height="50"
            />
            <v-btn color="red" @click="section=''" small>Regresar</v-btn>
          </v-col>-->
          
          <v-col cols="12">
            <v-row>
              <v-col cols="12">
                <h1 style="font-size: 7vw; font-family: Arial, Helvetica, sans-serif; font-weight: bolder; text-align: center; text-shadow: 1px 1px 4px #000; color:#FFF;">Ubica tus Centros de Servicio más cercanos</h1>
              </v-col>
              <v-col cols="12">
                <template v-if="versionSearch === 'autocomplete'">
                  <v-autocomplete
                    v-model="estado"
                    :items="estados"
                    label="Estado"
                    item-text="name"
                    item-value="value"
                    variant="solo"
                  ></v-autocomplete>

                  <v-autocomplete
                    v-model="ciudad"
                    :items="ciudades"
                    label="Ciudad"
                    item-text="name"
                    item-value="value"
                    :disabled="ciudades.length === 0"
                    variant="solo"
                  ></v-autocomplete>
                </template>

                <template v-else>
                  <v-select
                    v-model="estado"
                    :items="estados"
                    label="Estado"
                    item-text="name"
                    item-value="value"
                    variant="solo"
                  ></v-select>

                  <v-select
                    v-model="ciudad"
                    :items="ciudades"
                    label="Ciudad"
                    item-text="name"
                    item-value="value"
                    :disabled="ciudades.length === 0"
                    variant="solo"
                  ></v-select>
                </template>
              </v-col>
              <v-col cols="12">
                <v-btn  color="grey-darken-1" @click="section=''" small>Regresar</v-btn>
                <v-btn prepend-icon="mdi-store" stacked  color="deep-orange" :disabled="!estado || !ciudad" @click="searchCentroDeServicio()" small>
                  <span><i class="far fa-search"></i>Buscar Centros</span>
                </v-btn>
                <!--<v-btn prepend-icon="mdi-store" stacked  color="deep-orange" @click="section='Centros de Servicio'">Buscar Centros</v-btn>-->
              </v-col>
            </v-row>
          </v-col>
      </v-row>
      </v-container>
    </v-content>
    <v-content v-else-if="section=='Buscar mi Bateria' && results.length > 0 && !noExisteFichaTecnica" 
      class="appColorBack" 
      :style="{backgroundImage: `url(${backgroundImage})`, height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', backgroundSize: 'cover', backgroundPosition: 'center center', paddingTop: '80px'}">

      <v-tabs 
      v-model="selectedResultIndex" 
      background-color="deep-orange" 
      dark 
      align-tabs="center"
      style="width: 100%; top:10%; position: fixed; z-index: 999;"
    >
      <v-tab 
          v-for="(result, index) in results" 
          :key="index"
          style="color: #FFF;"
        >
          Batería {{ index + 1 }}
        </v-tab>
      </v-tabs>

      <v-container class="fill-height" fluid>
        <v-row class="text-center d-flex align-center justify-center" no-gutters style="margin-bottom: 0;">

          <!-- Carrusel para la imagen de la batería seleccionada cycle hide-delimiters -->
          <v-carousel 
          v-if="currentResult.nombre_del_archivo.length > 0"
          cycle hide-delimiters
          height="40vh"
          style="margin-bottom: 0;"
          :show-arrows="false" 
          class="carousel-no-controls"
          :v-cloak="false"
          >
            <v-carousel-item
              v-for="(item, i) in currentResult.nombre_del_archivo"
              :key="i"
            >
              <v-img
                :src="`https://jakiodes.com/pgtfiles/${item}`"
                height="100%"
                contain
                style="margin-top: 1%;"
                @error="handleError(i)"
              >
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <span style="color:#FFF;">Imagen no encontrada</span>
                  </v-row>
                </template>
              </v-img>
            </v-carousel-item>
          </v-carousel>

          <!-- Especificaciones de la batería seleccionada -->
          <v-container class="mt-0" fluid>
            <v-row no-gutters style="margin-top: 10px;">
              <v-col cols="12">
                <h1 style="margin: 0; padding: 0; font-size: 5vw; font-family: Arial, Helvetica, sans-serif; font-weight: bolder; text-align: center; text-shadow: 1px 1px 4px #000; color:#FFF;">Especificaciones</h1>
              </v-col>
              <v-col cols="12">
                <v-row>
                  <v-col cols="12">
                    <v-card>
                      <v-row no-gutters>
                        <v-col cols="6" class="pa-2" style="background-color: #f5f5f5;">
                          <strong>Nombre del grupo</strong>
                        </v-col>
                        <v-col cols="6" class="pa-2" style="background-color: #e0e0e0;">
                          {{ currentResult.nombre_del_grupo }}
                        </v-col>
                      </v-row>
                      <v-row no-gutters>
                        <v-col cols="6" class="pa-2" style="background-color: #f5f5f5;">
                          <strong>Altura</strong>
                        </v-col>
                        <v-col cols="6" class="pa-2" style="background-color: #e0e0e0;">
                          {{ currentResult.altura }}
                        </v-col>
                      </v-row>
                      <v-row no-gutters>
                        <v-col cols="6" class="pa-2" style="background-color: #f5f5f5;">
                          <strong>Largo</strong>
                        </v-col>
                        <v-col cols="6" class="pa-2" style="background-color: #e0e0e0;">
                          {{ currentResult.largo }}
                        </v-col>
                      </v-row>
                      <v-row no-gutters>
                        <v-col cols="6" class="pa-2" style="background-color: #f5f5f5;">
                          <strong>Ancho</strong>
                        </v-col>
                        <v-col cols="6" class="pa-2" style="background-color: #e0e0e0;">
                          {{ currentResult.ancho }}
                        </v-col>
                      </v-row>
                      <v-row no-gutters>
                        <v-col cols="6" class="pa-2" style="background-color: #f5f5f5;">
                          <strong>Voltaje</strong>
                        </v-col>
                        <v-col cols="6" class="pa-2" style="background-color: #e0e0e0;">
                          {{ currentResult.voltaje }}
                        </v-col>
                      </v-row>
                      <v-row no-gutters>
                        <v-col cols="6" class="pa-2" style="background-color: #f5f5f5;">
                          <strong>Capacidad de arranque</strong>
                        </v-col>
                        <v-col cols="6" class="pa-2" style="background-color: #e0e0e0;">
                          {{ currentResult.capacidad_de_arranque }}
                        </v-col>
                      </v-row>
                      <v-row no-gutters>
                        <v-col cols="6" class="pa-2" style="background-color: #f5f5f5;">
                          <strong>Capacidad de reserva</strong>
                        </v-col>
                        <v-col cols="6" class="pa-2" style="background-color: #e0e0e0;">
                          {{ currentResult.capacidad_de_reserva }}
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
          
          <v-btn 
            :style="currentResult.ficha_tecnica !==null && currentResult.ficha_tecnica.length > 0 ? 'left: 40%;' : 'left: 50%;'" 
            color="deep-orange" 
            style="z-index: 999; position: fixed; transform: translateX(-50%); bottom: 0;" 
            icon 
            @click="imgsBateria=[];results=[];model=null;make=null;noExisteFichaTecnica=false;"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-btn 
            v-if="currentResult.ficha_tecnica !==null && currentResult.ficha_tecnica.length > 0" 
            color="deep-orange" 
            style="z-index: 999; position: fixed; left: 60%; transform: translateX(-50%); bottom: 0;" 
            icon 
            @click="openFichaTecnica"
          >
            <v-icon>mdi-file-image</v-icon>
          </v-btn>

          <!-- Modal para visualizar la imagen de la ficha técnica -->
          <v-dialog v-model="dialogFichaTecnica" v-if="currentResult.ficha_tecnica !==null && currentResult.ficha_tecnica.length > 0 " max-width="80%">
            <v-card>
              <v-img :src="'https://jakiodes.com/pgtfiles/'+currentResult.ficha_tecnica[0]" max-height="80vh" contain></v-img>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="deep-orange" @click="dialogFichaTecnica = false">Cerrar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </v-container>
    </v-content>

    <v-content v-else-if="section=='Centros de Servicio' && resultsCentros.length > 0" 
      class="appColorBack" 
      :style="{backgroundImage: `url(${backgroundImage})`, height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', backgroundSize: 'cover', backgroundPosition: 'center center', paddingTop: '80px'}">

      

      <v-container class="fill-height" fluid>
        <v-row class="text-center d-flex align-center justify-center" no-gutters style="margin-bottom: 0;">

          <v-col 
            v-for="(result, index) in resultsCentros" 
            :key="index" 
            cols="12" 
            sm="6" 
            md="4" 
            lg="3"
            class="mb-4"
          >
            <v-card class="mx-auto" max-width="90%">
              <v-card-title style="font-size: 12px;">{{ result.nombre }}</v-card-title>
              
              <v-card-subtitle>{{ result.ciudad }}, {{ result.estado }}</v-card-subtitle>
              <v-card-text>
                <p>
                  <strong>Teléfono:</strong> 
                  {{ result.telefono }}
                  <v-btn 
                    small 
                    icon 
                    style="padding: 0; min-width: 24px; height: 24px;"
                    @click="copyToClipboard(result.telefono)"
                  >
                    <v-icon style="font-size: 16px;">mdi-content-copy</v-icon>
                  </v-btn>
                </p>
                <p v-if="result.instagram">
                  <strong>Instagram:</strong>
                  <a :href="`https://www.instagram.com/${result.instagram}`" target="_blank" style="color: #1976D2; text-decoration: none;">
                    {{ result.instagram }}
                  </a>
                </p>
              </v-card-text>
              <v-card-actions>
                <v-btn color="deep-orange" text @click="openGoogleMaps(result.direccion, result.ciudad, result.estado)">
                  Ver en Google Maps
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          
          <v-btn 
            color="deep-orange" 
            style="z-index: 999; position: fixed; transform: translateX(-50%); bottom: 0; left:50%;" 
            icon 
            @click="resultsCentros=[];estado=null;ciudad=null;"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

          
        </v-row>
      </v-container>
    </v-content>

    
    <v-content  v-else class="appColorBack" :style="{backgroundImage: `url(${backgroundImage})`, height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundSize: 'cover', backgroundPosition: 'center center'}">
      <v-container class="fill-height" fluid>
        <v-row class="text-center">
            <v-col cols="12">
              <v-btn color="red" @click="section=''" small>Regresar</v-btn>
            </v-col>

            <v-col class="mb-4">
                <h1>Sección en construcción</h1>
            </v-col>

          </v-row>
      </v-container>
    </v-content>
  </v-app>

</template>

<script>
import backgroundImage from '../assets/back_app.png';
export default {
  name: 'HelloWorld',

  data: () => ({
    menuItems: ['Buscar mi Bateria', 'Centros de Servicio', 'Información y Noticias', 'Validar Garantía'],
    backgroundImage,
    drawer: false,
    section:'Buscar mi Bateria',
    marcas: [],
    make: null,
    autos: [],
    model: null,
    estados: [],
    estado: null,
    ciudades: [],
    ciudad: null,
    centro: null,
    year: '',
    resultBattery: [],
    imgsFichaTecnica: [],
    imgsBateria: [],
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight,
    showVideo: true,
    isMuted: true,
    noExisteFichaTecnica:false,
    especificacionesBateria:{},
    dialog: false,
    textError:'',
    titleError:'',
    versionSearch: 'select', // puede ser 'select'|'autocomplete'
    results: [], // Aquí se almacenarán los resultados de la búsqueda
    resultsCentros:[], //Aqui los resultados de los centros de servicio
    selectedResultIndex: 0, // Para rastrear el índice del resultado seleccionado
    dialogFichaTecnica: false, // Controla la visualización del modal de ficha técnica
    newsList: [
      {
        id: 1,
        title: 'Noticia 1',
        description: 'Descripción de la noticia 1',
        image: 'https://cdn.vuetifyjs.com/images/cards/desert.jpg',
      },
      {
        id: 2,
        title: 'Noticia 2',
        description: 'Descripción de la noticia 2',
        image: 'https://cdn.vuetifyjs.com/images/cards/docks.jpg',
      },
      {
        id: 3,
        title: 'Noticia 3',
        description: 'Descripción de la noticia 3',
        image: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg',
      },
    ],
    ecosystem: [
      {
        text: 'vuetify-loader',
        href: 'https://github.com/vuetifyjs/vuetify-loader/tree/next',
      },
      {
        text: 'github',
        href: 'https://github.com/vuetifyjs/vuetify/tree/next',
      },
      {
        text: 'awesome-vuetify',
        href: 'https://github.com/vuetifyjs/awesome-vuetify',
      },
    ],
    importantLinks: [
      {
        text: 'Chat',
        href: 'https://community.vuetifyjs.com',
      },
      {
        text: 'Made with Vuetify',
        href: 'https://madewithvuejs.com/vuetify',
      },
      {
        text: 'Twitter',
        href: 'https://twitter.com/vuetifyjs',
      },
      {
        text: 'Articles',
        href: 'https://medium.com/vuetify',
      },
      
    ],
    whatsNext: [
      {
        text: 'Explore components',
        href: 'https://vuetifyjs.com',
      },
      {
        text: 'Roadmap',
        href: 'https://vuetifyjs.com/introduction/roadmap/',
      },
      {
        text: 'Frequently Asked Questions',
        href: 'https://vuetifyjs.com/getting-started/frequently-asked-questions',
      },
    ],
  }),
  created() {
    window.addEventListener('resize', this.updateWindowSize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateWindowSize);
  },
  watch: {
    make(newValue) {
      if (newValue) {
        this.fetchAutos()
      }
    },

    estado(newValue) {
      if (newValue) {
        this.fetchCiudades()
      }
    },
  },
  computed: {
    currentResult() {
      return this.results[this.selectedResultIndex] || {};
    }
  },
  methods: {
    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        this.textError = `Número copiado: ${text}`;
        this.titleError = 'Éxito';
        this.dialog = true;
      }).catch(err => {
        this.textError = err;
        this.titleError = 'Error';
        this.dialog = true;
      });
    },
    openGoogleMaps(direccion, ciudad, estado) {
      const query = `${direccion}, ${ciudad}, ${estado}`;
      const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
      window.open(url, '_blank');
    },
    openFichaTecnica() {
      this.dialogFichaTecnica = true;
    },
    skipVideo() {
      this.showVideo = false;
    },
    skipVideoCentros() {
      this.showVideo = false;
      this.section = 'Centros de Servicio';
    },
    toggleMute() {
      this.isMuted = !this.isMuted;
      this.$refs.videoPlayer.muted = this.isMuted;
    },
    updateWindowSize() {
      this.windowWidth = window.innerWidth;
      this.windowHeight = window.innerHeight;
    },
    async fetchAutos() {
      this.model = null;
      this.imgsFichaTecnica = [];
      console.log('Buscando autos: '+this.make)
      if (this.make) {
        const response = await fetch(`https://demo2.esmtcx.solutions/pgt_get_autos.php?marca=${this.make}`);
        if (!response.ok) {
          
          this.textError = response.status;
          this.titleError = 'HTTP error!';
          this.dialog = true;
          //throw new Error(`HTTP error! status: ${response.status}`);
        }
        this.autos = await response.json();
      }
    },
    async fetchCiudades() {
      this.ciudad = null;
      console.log('Buscando ciudades: '+this.estado)
      if (this.estado) {
        const response = await fetch(`https://demo2.esmtcx.solutions/pgt_get_ciudades.php?ESTADO=${this.estado}`);
        if (!response.ok) {
          
          this.textError = response.status;
          this.titleError = 'HTTP error!';
          this.dialog = true;
          //throw new Error(`HTTP error! status: ${response.status}`);
        }
        this.ciudades = await response.json();
      }
    },
    async searchBattery() {
      if (this.make && this.model) {
        try {
          const response = await fetch(`https://demo2.esmtcx.solutions/pgt_search_battery.php?marca=${this.make}&auto=${this.model}`);
          
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          this.results = await response.json();

          if (this.results && this.results.length > 0) {
            this.selectedResultIndex = 0; // Mostrar la primera batería por defecto
            this.updateCurrentBattery();  // Actualiza la visualización con la primera batería
          } else {
            this.handleError('No se encontraron resultados para tu búsqueda');
          }
        } catch (error) {
          this.handleError(error.message);
        }
      }
    },

    async searchCentroDeServicio() {
      if (this.estado && this.ciudad) {
        try {
          const response = await fetch(`https://demo2.esmtcx.solutions/pgt_search_center.php?ESTADO=${this.estado}&CIUDAD=${this.ciudad}`);
          
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          this.resultsCentros = await response.json();

          /*if (this.results && this.results.length > 0) {
            this.selectedResultIndex = 0; // Mostrar la primera batería por defecto
            this.updateCurrentBattery();  // Actualiza la visualización con la primera batería
          } else {
            this.handleError('No se encontraron resultados para tu búsqueda');
          }*/
        } catch (error) {
          this.handleError(error.message);
        }
      }
    },

    updateCurrentBattery() {
      const currentBattery = this.results[this.selectedResultIndex];

      if (currentBattery) {
        this.especificacionesBateria = {
          "nombre_del_grupo": currentBattery.nombre_del_grupo,
          "altura": currentBattery.altura,
          "largo": currentBattery.largo,
          "ancho": currentBattery.ancho,
          "voltaje": currentBattery.voltaje,
          "capacidad_de_arranque": currentBattery.capacidad_de_arranque,
          "capacidad_de_reserva": currentBattery.capacidad_de_reserva,
          "garantia": currentBattery.garantia
        };

        this.imgsFichaTecnica = currentBattery.ficha_tecnica 
          ? currentBattery.ficha_tecnica.filter(name => name !== null && name !== '').map(name => `https://jakiodes.com/pgtfiles/${name}`) 
          : [];

        this.imgsBateria = currentBattery.nombre_del_archivo 
          ? currentBattery.nombre_del_archivo.filter(name => name !== null && name !== '').map(name => `https://jakiodes.com/pgtfiles/${name}`) 
          : [];

      } else {
        this.handleError('No se encontraron resultados para tu búsqueda');
      }
    },

    handleError(message) {
      this.textError = message;
      this.titleError = 'Error';
      this.dialog = true;
    },
  },
  async mounted() {
    const response = await fetch('https://demo2.esmtcx.solutions/pgt_get_marcas.php');
    if (!response.ok) {
      this.textError = 'No se encontró la ficha técnica para esta batería';
      this.titleError = 'Error';
      this.dialog = true;
      //throw new Error(`HTTP error! status: ${response.status}`);
    }
    this.marcas = await response.json();

    const responseEstados = await fetch('https://demo2.esmtcx.solutions/pgt_get_estados.php');
    if (!response.ok) {
      this.textError = 'No se pudo cargar la información de los Estados';
      this.titleError = 'Error';
      this.dialog = true;
      //throw new Error(`HTTP error! status: ${response.status}`);
    }
    this.estados = await responseEstados.json();
  },
  
}
</script>
<style scoped>
html, body{
  height: 100%;
  background-color:#000;
}

body{
  margin: 0;
  padding: 0;
  background-color:#000;
}

.appColorBack{
  background-color: #000;
}

.v-card {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.v-card-title {
  font-weight: bold;
}

.v-card-subtitle {
  color: gray;
}
.carousel-no-controls .v-window__prev, 
.carousel-no-controls .v-window__next, 
.carousel-no-controls .v-carousel__controls, 
.carousel-no-controls .v-carousel__controls__item {
  display: none !important;
}
</style>